/* Sanftes Einblenden beim Scrollen fuer die Sternkerze-Sections.
   Ohne JavaScript bleibt alles sichtbar — .sk-reveal wird erst
   hier gesetzt, damit nichts unsichtbar haengen bleibt. */
(function () {
  'use strict';
  var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduziert || !('IntersectionObserver' in window)) return;

  function start() {
    var ziele = document.querySelectorAll('[data-sk-reveal]');
    if (!ziele.length) return;

    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var verzoegerung = parseInt(el.getAttribute('data-sk-reveal-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-da'); }, verzoegerung);
        beobachter.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    Array.prototype.forEach.call(ziele, function (el) {
      el.classList.add('sk-reveal');
      beobachter.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
